module.exports = __webpack_public_path__ + "img/interface_rule.85cbecc9.png";